export const defaultDateTimeFormat = 'YYYY-MM-DD HH:mm:ss';
export const displayDateTimeFormat = 'D/M/YYYY, hh:mm A';
export const confidenceLevels = ['Greater than 70', 'Between 50 - 70', 'Less than 50'];
